import React, { useState, Fragment } from "react";
import moment from "moment";
import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";

import DialogModal from "@core/components/dialogmodal";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import ImageModal from "@core/components/imagemodal";
import CustomChip from "@core/components/mui/chip";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const renderClient = (params) => {
  const { row } = params;

  if (row.image) {
    return <img alt="img" src={`${row.image}`} width="40px" height="40px" />;
  }
};

const statusObj = {
  0: { title: "No", color: "error" },
  1: { title: "Yes", color: "primary" },
};

const AnnouncementList = (props) => {
  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    announcementList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    permission,
    role,
  } = props;

  const [deleteId, setDeleteId] = useState("");
  const [openImage, setOpenImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const handleImageModal = (url) => {
    setImageUrl(url);
    setOpenImage(true);
  };

  const handleClose = () => {
    setOpenImage(false);
  };

  const columns = [
    {
      flex: 0.4,
      minWidth: 70,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
    },
    {
      flex: 1,
      minWidth: 170,
      field: "created_at",
      headerName: "created date",
      renderCell: ({ row }) => {
        const formatDate = moment(row.created_at).format("DD-MM-yyyy HH:mm:ss");
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {formatDate}
          </Typography>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 80,
      field: "image",
      headerName: "Image",
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => handleImageModal(params.row.image)}
          >
            {renderClient(params)}
          </Box>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 120,
      field: "type",
      headerName: "Type",
      renderCell: ({ row }) => {
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {row.type === 0 ? "Non Member" : row.type === 1 ? "Member" : "All"}
          </Typography>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 120,
      field: "pin",
      headerName: "Pin",
      renderCell: ({ row }) => {
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {row.is_pin === true ? "Pin" : ""}
          </Typography>
        );
      },
    },
    {
      flex: 0.2,
      minWidth: 150,
      field: "priority",
      headerName: "Priority",
      renderCell: ({ row }) => {
        const status = statusObj[row.priority ? 1 : 0];

        return (
          <CustomChip
            size="small"
            skin="light"
            color={status.color}
            label={status.title}
            sx={{ "& .MuiChip-label": { textTransform: "capitalize" } }}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "order_sequence",
      headerName: "Sequence",
    },
    {
      flex: 0.8,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };
  const assemList = announcementList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      ...data,
    };
  });

  return (
    <Fragment>
      <Card>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          rowCount={Number(totalRecord)}
          page={pageNumber}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add", ""),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Announcement"
                : "",
              selectedRows: selectedRows,
              multiDelete: isPermissionAllow(permission.delete, role),
              onClickDelete: () => handleDeleteModal(),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}

      {openImage && (
        <ImageModal
          open={openImage}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </Fragment>
  );
};

export default AnnouncementList;
